import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraActionList } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraEmptyState, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
export function LcatsOnVehicle({ dossier: d }) {
    const reviewHref = `/registries/review-queue?kind=LCAT_CANDIDATE&vehicle=${encodeURIComponent(d.vehicleId)}`;
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Labor categories on this vehicle",
                action: `${d.entriesAsWritten} as written across holders · ${d.entriesMapped} mapped to anchors`
            }),
            d.anchors.length === 0 && /*#__PURE__*/ _jsx(SpecraEmptyState, {
                size: "compact",
                title: d.entriesMapped > 0 ? 'No mapped solicitation categories on this vehicle yet.' : 'No labor categories mapped on this vehicle yet.'
            }),
            /*#__PURE__*/ _jsx(SpecraActionList, {
                renderLink: renderRouterLink,
                getItemTestId: ()=>Testids.registryVehicle.lcatRow,
                trailing: null,
                items: d.anchors.map((row, i)=>({
                        id: row.anchor?.id ?? String(i),
                        label: row.anchor?.name ?? 'Labor category',
                        href: row.anchor ? registryHref(row.anchor) ?? undefined : undefined,
                        meta: `asked for in ${row.solicitationCount} solicitations · ${row.holdersPriced} holders priced it`
                    }))
            }),
            !!d.mismatch?.count && /*#__PURE__*/ _jsx(SpecraActionList, {
                items: [
                    {
                        id: 'mismatch',
                        eyebrow: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: "warning",
                            children: "Vehicle mismatch"
                        }),
                        label: d.mismatch.sampleText,
                        actions: /*#__PURE__*/ _jsx(SpecraLink, {
                            "data-testid": Testids.registryVehicle.mismatchReview,
                            renderLink: renderRouterLink,
                            href: reviewHref,
                            children: "Review →"
                        })
                    }
                ]
            })
        ]
    });
}
